import { render, staticRenderFns } from "./new_banner.vue?vue&type=template&id=f936c2e0&scoped=true&"
import script from "./new_banner.vue?vue&type=script&lang=js&"
export * from "./new_banner.vue?vue&type=script&lang=js&"
import style0 from "./new_banner.vue?vue&type=style&index=0&id=f936c2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f936c2e0",
  null
  
)

export default component.exports